import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { num } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Attendance() {
  const [dps, setDps] = useState([]);
  const [rows, setRows] = useState([]);
  const nav = useNavigate();

  useEffect(() => { api.get("/dp").then(({ data }) => setDps(data)); }, []);
  useEffect(() => {
    if (!dps.length) return;
    Promise.all(dps.slice(0, 20).map((d) => api.get(`/attendance/${d.id}`).then(({ data }) => ({ dp: d, ...data }))))
      .then(setRows);
  }, [dps]);

  return (
    <div>
      <PageHeader title="Attendance & Active Days" subtitle="Monthly active vs inactive days per delivery partner" />
      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>DP</TableHead><TableHead>Location</TableHead><TableHead className="text-right">Active Days</TableHead><TableHead className="text-right">Inactive Days</TableHead><TableHead className="text-right">Attendance %</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((r) => {
              const total = r.active_days + r.inactive_days;
              const pct = total ? Math.round((r.active_days / total) * 100) : 0;
              return (
                <TableRow key={r.dp.id} className="cursor-pointer" onClick={() => nav(`/dp/${r.dp.id}`)} data-testid={`attendance-row-${r.dp.fe_id}`}>
                  <TableCell className="font-semibold">{r.dp.full_name}<span className="ml-1 font-mono text-xs text-muted-foreground">{r.dp.fe_id}</span></TableCell>
                  <TableCell>{r.dp.location}</TableCell>
                  <TableCell className="text-right tabular text-emerald-500">{r.active_days}</TableCell>
                  <TableCell className="text-right tabular text-rose-500">{r.inactive_days}</TableCell>
                  <TableCell className="text-right tabular font-semibold">{pct}%</TableCell>
                  <TableCell><StatusBadge status={r.dp.status} /></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
